import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded'
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded'
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded'
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { Box, Container } from '@mui/system'
import { Dispatch } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import * as constants from '../../config/constants'
import Button from '../../shared/Button'
import { deviceList } from '../../store/devices'
import { getLanguage, getTheme, setLanguage, setTheme } from '../../store/ui'

const SettingsScreen = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<Dispatch<any>>()
  const language = useSelector(getLanguage)

  const theme = useSelector(getTheme)

  const navigate = useNavigate()
  const handleChangeMode = (event: React.MouseEvent<HTMLElement>, newTheme: string) => {
    dispatch(setTheme(newTheme))
  }
  const handleChangeLanguage = (event: React.MouseEvent<HTMLElement>, newLanguage: string) => {
    dispatch(setLanguage(newLanguage))
  }
  const handleDevices = () => {
    navigate(`/${constants.DEVICES}`)
    dispatch(deviceList({ id: '', simNo: '' }))
  }
  const changeLanguageHandler = async (lng: string) => {
    try {
      await i18n.changeLanguage(lng)
    } catch (error) {
    }
  }
  useEffect(() => {
    void changeLanguageHandler(language)
    if (language === 'fa') {
      document.dir = 'rtl'
    } else {
      document.dir = 'ltr'
    }
  }, [language])
  return (
    <Container fixed maxWidth='xs'>
      <Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
        <img alt='Logo' src='images/TinyLogo.png' />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 23,

          // backgroundImage: `url(${'images/background.jpg'})`,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography dir='ltr'>{t('screens.settings.theme_title_text')}</Typography>
          <ToggleButtonGroup dir='ltr' exclusive onChange={handleChangeMode} value={theme}>
            <ToggleButton value={constants.THEME_LIGHT_MODE}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <LightModeRoundedIcon sx={{ fontSize: 32 }} />
                <Typography sx={{ mx: 1 }} variant='subtitle1'>
                  {t('screens.settings.light_button_text')}
                </Typography>
              </Box>
            </ToggleButton>
            <ToggleButton value={constants.THEME_DARK_MODE}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <DarkModeRoundedIcon sx={{ fontSize: 32 }} />
                <Typography sx={{ mx: 1 }} variant='subtitle1'>
                  {t('screens.settings.dark_button_text')}
                </Typography>
              </Box>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 5 }}>
          <Typography dir='ltr'>{t('screens.settings.language_title_text')}</Typography>
          <ToggleButtonGroup dir='ltr' exclusive onChange={handleChangeLanguage} value={language}>
            <ToggleButton value={constants.APP_ENGLISH_LANGUAGE}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <TranslateRoundedIcon sx={{ fontSize: 32 }} />
                <Typography sx={{ mx: 1 }} variant='subtitle1'>
                  {t('screens.settings.english_button_text')}
                </Typography>
              </Box>
            </ToggleButton>
            <ToggleButton value={constants.APP_PERSIAN_LANGUAGE}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <TranslateRoundedIcon sx={{ fontSize: 32 }} />
                <Typography sx={{ mx: 1 }} variant='subtitle1'>
                  {t('screens.settings.persian_button_text')}
                </Typography>
              </Box>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Box sx={{ mt: 5 }}>
          <Button onClick={handleDevices} sx={{ width: '100%' }} variant='contained'>
            {t('screens.settings.device_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default SettingsScreen
